import request from '@/utils/request'

function normalizeOptionalEmail(data) {
  if (
    data
    && Object.prototype.hasOwnProperty.call(data, 'email')
    && typeof data.email === 'string'
    && data.email.trim() === ''
  ) {
    return { ...data, email: null }
  }
  return data
}

// 获取部门列表
export function getDepartments() {
  return request({
    url: '/api/v1/users/departments',
    method: 'get'
  })
}

// 获取行业列表
export function getIndustries() {
  return request({
    url: '/api/v1/users/industries',
    method: 'get'
  })
}

// 获取单位列表
export function getOrganizations() {
  return request({
    url: '/api/v1/users/organizations',
    method: 'get'
  })
}

// 获取来源渠道列表
export function getSourceChannels() {
  return request({
    url: '/api/v1/users/source-channels',
    method: 'get'
  })
}

// 获取用户列表
export function getUsers(params) {
  // 确保tenant_id是数字类型
  if (params && params.tenant_id !== undefined && params.tenant_id !== null) {
    params.tenant_id = Number(params.tenant_id);
    console.log('处理后的租户ID参数:', params.tenant_id, typeof params.tenant_id);
  }
  
  // 确保username和role参数正确传递
  if (params) {
    // 确保username是字符串类型且非空
    if (params.username !== undefined && params.username !== null && params.username.trim() !== '') {
      params.username = params.username.trim();
      console.log('处理后的用户名参数:', params.username);
    } else if (params.username !== undefined) {
      // 如果username为空字符串或null，则删除该参数
      delete params.username;
    }
    
    // 确保role是字符串类型且非空
    if (params.role !== undefined && params.role !== null && params.role.trim() !== '') {
      params.role = params.role.trim();
      console.log('处理后的角色参数:', params.role);
    } else if (params.role !== undefined) {
      // 如果role为空字符串或null，则删除该参数
      delete params.role;
    }
  }
  
  // console.log('获取用户列表，参数:', JSON.stringify(params));
  return request({
    url: '/api/v1/users/',
    method: 'get',
    params,
    // 禁用缓存，确保每次都获取最新数据
    headers: {
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache'
    }
  }).then(response => {
    // console.log('获取用户列表原始响应:', JSON.stringify(response));
    return response;
  }).catch(error => {
    console.error('获取用户列表错误:', error);
    return { data: { data: [], total: 0 } };
  });
}

// 获取用户详情
export function getUser(id) {
  console.log('获取用户详情，ID:', id);
  return request({
    url: `/api/v1/users/${id}`,
    method: 'get'
  }).then(response => {
    console.log('获取用户详情响应:', response);
    return response.data;
  }).catch(error => {
    console.error('获取用户详情错误:', error);
    throw error;
  });
}

// 解析校验/业务错误，供用户管理表单内联展示
function enhanceValidationError(error) {
  if (!error.response?.data) {
    return error
  }

  const errorData = error.response.data
  const status = error.response.status

  if (status === 422 && errorData.errors) {
    const fieldErrors = errorData.errors
      .filter(err => Array.isArray(err.loc) && err.loc.length > 0)
      .map(err => ({
        field: err.loc[err.loc.length - 1],
        message: err.msg || '输入值无效'
      }))

    const enhancedError = new Error(
      fieldErrors.map(e => e.message).join('; ') || '输入数据验证失败，请检查表单'
    )
    enhancedError.response = error.response
    enhancedError.isValidationError = true
    enhancedError.fieldErrors = fieldErrors
    return enhancedError
  }

  if (typeof errorData.detail === 'string') {
    const detail = errorData.detail
    const enhancedError = new Error(detail)
    enhancedError.response = error.response

    if (
      detail.includes('用户名')
      || detail.includes('手机')
      || detail.includes('已存在')
      || detail.includes('已注册')
    ) {
      enhancedError.isDuplicateError = true
    }

    const field = detail.includes('手机')
      ? 'phone'
      : detail.includes('用户名')
        ? 'username'
        : detail.includes('密码')
          ? 'password'
          : null

    if (field && (status === 400 || status === 422)) {
      enhancedError.isValidationError = true
      enhancedError.fieldErrors = [{ field, message: detail }]
    }

    return enhancedError
  }

  return error
}

// 创建用户
export function createUser(data) {
  console.log('创建用户，数据:', data);
  return request({
    url: '/api/v1/users/',
    method: 'post',
    data: normalizeOptionalEmail(data),
    // 禁用默认错误提示，由调用方处理错误
    noErrorNotification: true,
    customErrorHandling: true
  }).then(response => {
    console.log('创建用户响应:', response);
    return response;
  }).catch(error => {
    console.error('创建用户错误:', error);
    throw enhanceValidationError(error);
  });
}

// 更新用户
export function updateUser(id, data) {
  console.log('更新用户信息，ID:', id, '数据:', data);
  return request({
    url: `/api/v1/users/${id}`,
    method: 'put',
    data: normalizeOptionalEmail(data),
    noErrorNotification: true,
    customErrorHandling: true
  }).then(response => {
    console.log('更新用户信息响应:', response);
    return response.data;
  }).catch(error => {
    console.error('更新用户信息错误:', error);
    throw enhanceValidationError(error);
  });
}

// 重置用户密码（管理员功能）
export function resetUserPassword(userId) {
  console.log('重置用户密码，用户ID:', userId);
  return request({
    url: `/api/v1/users/${userId}/reset-password`,
    method: 'put'
  }).then(response => {
    console.log('重置用户密码响应:', response);
    // 响应拦截器已经处理了response.data，这里直接返回
    return response;
  }).catch(error => {
    console.error('重置用户密码错误:', error);
    throw error;
  });
}

// 删除用户
export function deleteUser(id) {
  console.log('删除用户，ID:', id);
  return request({
    url: `/api/v1/users/${id}`,
    method: 'delete',
    // 强制刷新，确保删除操作不使用缓存
    headers: {
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'If-Modified-Since': '0'
    }
  }).then(response => {
    console.log('删除用户响应:', response);
    return response.data;
  }).catch(error => {
    console.error('删除用户错误:', error);
    if (error.response && error.response.status === 404) {
      console.error('用户不存在或已被删除:', error.response.data);
    }
    throw error;
  });
}

// 获取当前用户信息
export function getCurrentUser() {
  return request({
    url: '/api/v1/users/me',
    method: 'get'
  }).then(response => {
    // console.log('获取当前用户信息响应:', response);
    return response.data || response;
  }).catch(error => {
    console.error('获取当前用户信息错误:', error);
    throw error;
  });
}

// 更新当前用户信息
export function updateCurrentUser(data) {
  return request({
    url: '/api/v1/users/me',
    method: 'put',
    data
  })
}

export function sendCurrentEmailChangeConfirmation(data) {
  return request({
    url: '/api/v1/users/me/email-change/current-confirmation',
    method: 'post',
    data
  })
}

export function sendNewEmailChangeActivation(data) {
  return request({
    url: '/api/v1/users/me/email-change/new-email-activation',
    method: 'post',
    data
  })
}

// 更换手机号 - 第一步：给当前手机号发送短信验证码
export function sendChangePhoneOldSms(data) {
  return request({
    url: '/api/v1/auth/change-phone/send-old-sms',
    method: 'post',
    data,
    customErrorHandling: true
  })
}

// 更换手机号 - 第一步：校验当前手机号 + 短信码，拿到一次性 change_token
export function verifyChangePhoneOld(data) {
  return request({
    url: '/api/v1/auth/change-phone/verify-old',
    method: 'post',
    data,
    customErrorHandling: true
  })
}

// 更换手机号 - 第二步：给新手机号发送短信验证码
export function sendChangePhoneNewSms(data) {
  return request({
    url: '/api/v1/auth/change-phone/send-new-sms',
    method: 'post',
    data,
    customErrorHandling: true
  })
}

// 更换手机号 - 第二步：用 change_token + 新手机号短信码完成换绑
export function confirmChangePhone(data) {
  return request({
    url: '/api/v1/auth/change-phone/confirm',
    method: 'post',
    data,
    customErrorHandling: true
  })
}

// 获取用户-租户映射关系
export function getUserTenantMapping() {
  return request({
    url: '/api/v1/user-tenant-mapping/',
    method: 'get'
  })
}

// 手动指定用户的租户
export function updateUserTenant(userId, tenantId) {
  const data = tenantId === undefined ? { tenant_id: null } : { tenant_id: tenantId };
  
  return request({
    url: `/api/v1/users/${userId}/tenant`,
    method: 'put',
    data
  })
}

/**
 * 获取用户关联的租户列表
 * @param {number} userId - 用户ID
 * @param {Object} config - 额外的请求配置
 * @returns {Promise<Array>} - 用户关联的租户列表
 */
export function getUserTenants(userId, config = {}) {
  if (!userId) {
    console.error('获取用户租户列表失败: 未提供用户ID');
    return Promise.reject(new Error('未提供用户ID'));
  }

  // 添加时间戳参数避免缓存
  const timestamp = new Date().getTime();
  
  // 构建合并后的请求配置
  const mergedConfig = {
    url: `/api/v1/users/${userId}/tenants`,
    method: 'get',
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
      ...(config.headers || {})
    },
    params: {
      _t: timestamp,
      ...(config.params || {})
    },
    ...config
  };
  
  // 确保params和headers不被覆盖
  delete mergedConfig.params.headers;
  
  console.log(`获取用户(ID: ${userId})的租户列表, 配置:`, mergedConfig);
  return request(mergedConfig).then(response => {
    // 检查响应格式，并保存原始响应用于调试
    console.log(`获取租户列表原始响应:`, JSON.stringify(response));
    
    // 处理响应数据
    let processedData;
    
    if (Array.isArray(response)) {
      // 响应直接是数组
      processedData = { data: response };
      console.log(`用户(ID: ${userId})有${response.length}个租户 [数组格式]`);
    } else if (response && response.data && Array.isArray(response.data)) {
      // 标准格式：{ data: [...] }
      processedData = response;
      console.log(`用户(ID: ${userId})有${response.data.length}个租户 [标准对象格式]`);
    } else if (response && typeof response === 'object') {
      // 其他对象格式，尝试提取数据
      const possibleArrayData = Object.values(response).find(val => Array.isArray(val));
      if (possibleArrayData) {
        processedData = { data: possibleArrayData };
        console.log(`用户(ID: ${userId})有${possibleArrayData.length}个租户 [嵌套对象格式]`);
      } else {
        // 未找到数组，构建空数组响应
        console.warn(`响应中未找到租户数组数据:`, response);
        processedData = { data: [] };
      }
    } else {
      // 未知格式，返回空数组
      console.warn(`获取用户租户返回的数据格式不符合预期:`, response);
      processedData = { data: [] };
    }
    
    // 确保每个租户对象都有必要的字段
    if (processedData && processedData.data) {
      processedData.data = processedData.data.map(tenant => ({
        ...tenant,
        id: tenant.id || 0,
        name: tenant.name || '未命名租户',
        code: tenant.code || '',
        role: tenant.role || 'USER',
        is_active: tenant.is_active !== false, // 默认为true
        is_current: !!tenant.is_current
      }));
    }
    
    return processedData;
  }).catch(error => {
    console.error(`获取用户(ID: ${userId})租户列表失败:`, error);
    
    // 构建友好的错误信息
    let errorMessage = '获取租户列表失败';
    if (error.response) {
      if (error.response.status === 401) {
        errorMessage = '未授权访问，请重新登录';
      } else if (error.response.status === 403) {
        errorMessage = '没有权限访问租户信息';
      } else if (error.response.status === 404) {
        errorMessage = '未找到用户或租户信息';
      } else if (error.response.data && error.response.data.detail) {
        errorMessage = `获取租户失败: ${error.response.data.detail}`;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    const enhancedError = new Error(errorMessage);
    if (error.response) {
      enhancedError.response = error.response;
    }
    throw enhancedError;
  });
}

/**
 * 添加用户到租户
 * @param {number} tenantId - 租户ID
 * @param {number} userId - 用户ID
 * @param {string} role - 用户在租户中的角色
 * @returns {Promise<Object>} - 操作结果
 */
export function addUserToTenant(tenantId, userId, role) {
  console.log(`添加用户到租户, tenantId=${tenantId}, userId=${userId}, role=${role}`);
  return request({
    url: `/api/v1/tenants/${tenantId}/users/${userId}`,
    method: 'post',
    headers: {
      'Content-Type': 'text/plain'  // 确保内容类型正确
    },
    data: role  // 直接发送角色字符串而非JSON对象
  });
}

/**
 * 从租户中移除用户
 * @param {number} tenantId - 租户ID
 * @param {number} userId - 用户ID
 * @returns {Promise<Object>} - 操作结果
 */
export function removeUserFromTenant(tenantId, userId) {
  return request({
    url: `/api/v1/tenants/${tenantId}/users/${userId}`,
    method: 'delete'
  });
}

/**
 * 设置用户当前租户
 * @param {number} userId - 用户ID
 * @param {number} tenantId - 租户ID
 * @param {Object} config - 额外的请求配置
 * @returns {Promise<Object>} - 操作结果
 */
export function setUserCurrentTenant(userId, tenantId, config = {}) {
  console.log(`设置用户 ${userId} 的当前租户为 ${tenantId}`, config);
  
  // 添加默认请求配置
  const defaultConfig = {
    headers: {
      'Content-Type': 'application/json'
    }
  };
  
  // 合并配置
  const mergedConfig = {
    ...defaultConfig,
    ...config,
    headers: {
      ...defaultConfig.headers,
      ...(config.headers || {})
    }
  };
  
  // 记录完整请求配置和时间
  mergedConfig._requestTime = new Date().toISOString();
  console.log('完整请求配置:', mergedConfig);
  
  return request({
    url: `/api/v1/users/${userId}/current-tenant/${tenantId}`,
    method: 'post',
    ...mergedConfig
  }).then(response => {
    console.log(`设置用户 ${userId} 的当前租户为 ${tenantId} 成功:`, response);
    
    // 更新localStorage中的租户ID
    if (response && response.tenant_id) {
      localStorage.setItem('current_tenant_id', response.tenant_id);
      console.log('更新localStorage中的租户ID:', response.tenant_id);
    }
    
    // 如果响应中有完整的租户信息，也保存到localStorage
    if (response && response.tenant) {
      localStorage.setItem('current_tenant', JSON.stringify(response.tenant));
      console.log('更新localStorage中的租户信息:', response.tenant);
    }
    
    return response;
  }).catch(error => {
    console.error(`设置用户 ${userId} 的当前租户为 ${tenantId} 失败:`, error);
    throw error;
  });
}

/**
 * 更新用户语言偏好
 * @param {string} languagePreference - 语言偏好 (zh-CN/en/auto)
 * @returns {Promise<Object>} - 更新结果
 */
export function updateUserLanguagePreference(languagePreference) {
  return request({
    url: '/api/v1/users/me/language',
    method: 'put',
    data: {
      language_preference: languagePreference
    }
  });
}

/**
 * 获取用户语言偏好
 * @returns {Promise<Object>} - 用户语言偏好信息
 */
export function getUserLanguagePreference() {
  return request({
    url: '/api/v1/users/me/language',
    method: 'get'
  });
}

/**
 * 批量添加用户到多个租户
 * @param {number} userId - 用户ID
 * @param {number[]} tenantIds - 租户ID列表
 * @param {string} role - 用户角色
 * @returns {Promise} - 返回操作结果
 */
export function batchAddUserToTenants(userId, tenantIds, role) {
  return request({
    url: `/api/v1/users/${userId}/batch-tenants`,
    method: 'post',
    data: {
      tenant_ids: tenantIds,
      role: role
    }
  });
}

/**
 * 更新用户在租户中的角色
 * @param {number} tenantId - 租户ID
 * @param {number} userId - 用户ID
 * @param {string} role - 新角色
 * @returns {Promise<Object>} - 操作结果
 */
export function updateUserRole(tenantId, userId, role) {
  console.log(`更新用户角色，租户ID: ${tenantId}, 用户ID: ${userId}, 角色: ${role}`);
  return request({
    url: `/api/v1/tenants/${tenantId}/users/${userId}/role`,
    method: 'put',
    params: { role },  // 将role作为查询参数传递
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

// 获取用户列表
export function getUserList(params) {
  return request({
    url: '/api/v1/users/',
    method: 'get',
    params
  })
}

// 搜索用户
export function searchUsers(params) {
  return request({
    url: '/api/v1/users/search',
    method: 'get',
    params
  })
}

// 为用户插入示例数据
export function insertSampleData(userId, targetIds = [211, 213, 218]) {
  console.log(`为用户 ${userId} 插入示例数据，靶点ID列表:`, targetIds);
  
  return request({
    url: `/api/v1/targets/copy-sample-data/${userId}`,
    method: 'post',
    data: targetIds,
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(response => {
    console.log('插入示例数据成功:', response);
    return response;
  }).catch(error => {
    console.error('插入示例数据失败:', error);
    
    // 构建友好的错误信息
    let errorMessage = '插入示例数据失败';
    if (error.response) {
      const status = error.response.status;
      if (status === 401) {
        errorMessage = '未授权访问，请重新登录';
      } else if (status === 403) {
        errorMessage = '权限不足，只有管理员可以执行此操作';
      } else if (status === 404) {
        errorMessage = '未找到对应的API端点或用户不存在';
      } else if (error.response.data && error.response.data.detail) {
        errorMessage = error.response.data.detail;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    const enhancedError = new Error(errorMessage);
    if (error.response) {
      enhancedError.response = error.response;
    }
    throw enhancedError;
  });
}

// 设置用户为正式用户或试用用户
export function setFormalUser(userId, isFormal) {
  console.log('设置用户类型，用户ID:', userId, '是否正式用户:', isFormal);
  return request({
    url: `/api/v1/users/${userId}/set-formal-user`,
    method: 'post',
    data: { is_formal: isFormal }
  }).then(response => {
    console.log('设置用户类型响应:', response);
    return response.data;
  }).catch(error => {
    console.error('设置用户类型错误:', error);
    throw error;
  });
}

// 获取用户任务统计信息
export function getUserTaskStatistics() {
  return request({
    url: '/api/v1/users/task-statistics',
    method: 'get'
  })
}

// 获取用户消费记录详情
export function getUserConsumptionRecords(params = {}) {
  return request({
    url: '/api/v1/users/consumption-records',
    method: 'get',
    params
  })
}

// 测试导出接口
export function testExportUsers(params = {}) {
  console.log('测试导出用户数据，参数:', params);
  return request({
    url: '/api/v1/users/export-test',
    method: 'get',
    params
  }).then(response => {
    console.log('测试导出用户数据响应:', response);
    return response.data;
  }).catch(error => {
    console.error('测试导出用户数据错误:', error);
    throw error;
  });
}

// 导出用户数据
export function exportUsers(params = {}) {
  console.log('导出用户数据，参数:', params);
  return request({
    url: '/api/v1/users/export',
    method: 'get',
    params,
    responseType: 'blob',  // 重要：指定响应类型为blob
    returnFullResponse: true,  // 返回完整响应以获取文件名
    headers: {
      'Accept': 'text/csv'
    }
  }).then(response => {
    console.log('导出用户数据响应:', response);
    // 创建下载链接
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
    const link = document.createElement('a');
    link.href = url;
    
    // 从响应头获取文件名，如果没有则使用默认文件名
    let filename = 'users_export.csv';
    const contentDisposition = response.headers['content-disposition'];
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
      if (filenameMatch) {
        filename = filenameMatch[1];
      }
    }
    
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    return { success: true, filename };
  }).catch(error => {
    console.error('导出用户数据错误:', error);
    throw error;
  });
}
